module.exports = __webpack_public_path__ + "static/media/person-active.dd1aa246.svg";